import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Body, Footer, Popup, Header } from '@calendly/ui/components/popup'
import { useState } from 'react'

import ErrorMessage from 'components/core/error_message'

import { EmailVerification } from './email_verification'

export const Email2FAModal = ({ onClose, onContinue }) => {
  const [error, setError] = useState(null)

  const handleSubmit = ({ code }) => {
    onContinue({ code })
  }

  const resetErrors = () => {
    setError(null)
  }

  return (
    <Popup onClose={onClose} title={I18n.t('publisher.email_2fa_modal.title')}>
      <Header>{I18n.t('publisher.email_2fa_modal.two_factor_auth_request')}</Header>
      <Body>
        <EmailVerification handleSubmit={handleSubmit} error={error} reset={resetErrors} />
        {!!error && <ErrorMessage message={error} />}
      </Body>
      <Footer>
        <Button decoration="secondary-outline" onClick={onClose}>{I18n.t('publisher.action.cancel')}</Button>
        {/* <Button onClick={onContinue}>{I18n.t('publisher.action.continue')}</Button> */}
      </Footer>
    </Popup>
  )
}
